var _defs, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScipy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cy: "70%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0053A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0053A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00264a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 33l3-2m0-3v3h2.5",
    fill: "none",
    stroke: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    fill: "url(#a)",
    r: 47.5,
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 77c24-27 23-4 44 2 18 4 23-15 10-25-7-6-16-5-23-9-10-5-8-20 2-23 29-10 16 32 49 13",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32l5 11 9-8-1-3z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScipy);
export default __webpack_public_path__ + "static/media/scipy.f0f9f1328ba226b3b75a42a9984e18dd.svg";
export { ForwardRef as ReactComponent };